import { useEffect, useState } from 'react';

const isFinePointer = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(pointer: fine)').matches &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [visible, setVisible] = useState(false);
  const [point, setPoint] = useState({ x: 0, y: 0 });
  const [halo, setHalo] = useState({ x: 0, y: 0 });
  const [isPressed, setIsPressed] = useState(false);
  const [isHoveringAction, setIsHoveringAction] = useState(false);

  useEffect(() => {
    if (!isFinePointer()) return undefined;

    setEnabled(true);
    document.documentElement.classList.add('has-custom-cursor');

    let animationId;
    let targetX = 0;
    let targetY = 0;

    const follow = () => {
      setHalo((current) => ({
        x: current.x + (targetX - current.x) * 0.18,
        y: current.y + (targetY - current.y) * 0.18,
      }));
      animationId = window.requestAnimationFrame(follow);
    };

    const handleMove = (event) => {
      targetX = event.clientX;
      targetY = event.clientY;
      setPoint({ x: event.clientX, y: event.clientY });
      setVisible(true);
    };

    const handleLeave = () => setVisible(false);
    const handleDown = () => setIsPressed(true);
    const handleUp = () => setIsPressed(false);

    const refreshHoverState = (event) => {
      const interactiveTarget = event.target.closest(
        'a, button, input, textarea, select, [role="button"], [data-cursor="interactive"]'
      );
      setIsHoveringAction(Boolean(interactiveTarget));
    };

    animationId = window.requestAnimationFrame(follow);

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseover', refreshHoverState);
    window.addEventListener('mousedown', handleDown);
    window.addEventListener('mouseup', handleUp);
    document.documentElement.addEventListener('mouseleave', handleLeave);

    return () => {
      window.cancelAnimationFrame(animationId);
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseover', refreshHoverState);
      window.removeEventListener('mousedown', handleDown);
      window.removeEventListener('mouseup', handleUp);
      document.documentElement.removeEventListener('mouseleave', handleLeave);
      document.documentElement.classList.remove('has-custom-cursor');
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div
        className={`custom-cursor-ring${visible ? ' is-visible' : ''}${
          isHoveringAction ? ' is-hovering' : ''
        }${isPressed ? ' is-pressed' : ''}`}
        style={{
          transform: `translate3d(${halo.x}px, ${halo.y}px, 0)`,
        }}
      />
      <div
        className={`custom-cursor-dot${visible ? ' is-visible' : ''}${
          isHoveringAction ? ' is-hovering' : ''
        }${isPressed ? ' is-pressed' : ''}`}
        style={{
          transform: `translate3d(${point.x}px, ${point.y}px, 0)`,
        }}
      />
    </>
  );
};

export default CustomCursor;
